import type { App } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

const store = createPinia();

store.use(piniaPluginPersistedstate);

export const setupStore = (app: App<Element>) => {
  console.log('注册 store')
  app.use(store);
};

export { store };
